import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useAuthContext();

  if (loading) return <div>Loading...</div>;
  return user ? children : <Navigate to='/login' replace />;
};

export default PrivateRoute;
